export var ClientSummarySortField = /*#__PURE__*/ function(ClientSummarySortField) {
    ClientSummarySortField["Name"] = "name";
    ClientSummarySortField["Status"] = "status";
    ClientSummarySortField["ClientType"] = "clientType";
    ClientSummarySortField["Owner"] = "owner";
    ClientSummarySortField["Tax"] = "tax";
    ClientSummarySortField["LastInvoiceDate"] = "lastInvoiceDate";
    ClientSummarySortField["NextInvoiceDate"] = "nextInvoiceDate";
    ClientSummarySortField["ReferenceField"] = "referenceField";
    return ClientSummarySortField;
}({});
export var ClientSummarySortDirection = /*#__PURE__*/ function(ClientSummarySortDirection) {
    ClientSummarySortDirection["Asc"] = "asc";
    ClientSummarySortDirection["Desc"] = "desc";
    return ClientSummarySortDirection;
}({});
export const CLIENT_SUMMARY_STATUSES = [
    'active',
    'archived'
];
export const CLIENT_SUMMARY_TYPES = [
    'business',
    'individual'
];
export const CLIENT_SUMMARIES_MAX_LIMIT = 100;
export const CLIENT_REFERENCE_FIELD_VALUES_MAX = 1000;
export const CLIENT_REFERENCE_FILTER_NOT_SET = '__not_set__';
